import { TankAsset } from '../types'

export function resolveUrl(url: string): string {
  // const state: ReduxStoreType = store.getState()
  // if (state.env.env !== 'TANK' && state.env.env !== 'EMBED') {
  // 	let actualUrl = url
  // 	if (url.toLowerCase().indexOf('http') === 0) {
  // 		const urlObject = new URL(url)
  // 		actualUrl = urlObject.pathname + (urlObject.search || '')
  // 	}
  // 	if (actualUrl[0] == '/') actualUrl = actualUrl.substr(1)
  // 	return actualUrl
  // }
  return url
}

export function getImageUrl(
  file: TankAsset,
  size: string = 'cockpit-small',
  extension: string | null = null,
  getOriginal: boolean = false
) {
  if (typeof file != 'object' || file instanceof Array || !file.filename || typeof size != 'string') return false
  const dot = file.filename.lastIndexOf('.')
  if (!file.slug) file.slug = file.filename.substr(0, dot)
  if (!file.extension) file.extension = file.filename.substr(dot + 1, file.filename.length)
  if (file.extension == 'svg') return getAssetUrl(file)
  const originalStr = getOriginal ? 'original/' : ''
  const url = `/generated/${originalStr}${size}/${file.slug}.${extension || file.extension || 'jpg'}`
  return resolveUrl(url)
}

export function getAssetUrl(file: TankAsset) {
  if (
    file instanceof Array ||
    (typeof file != 'object' && typeof file != 'string') ||
    (typeof file == 'object' && !file.filename)
  )
    throw new Error('is not asset shape')

  const filename = typeof file == 'string' ? file : file.filename
  if (filename.indexOf('/assets/') >= 0) return filename
  const url = '/uploads/' + filename
  return resolveUrl(url)
}
